export function generateChromaName(str) {

    console.log('user input: ' + str);

    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();
  
    // Replace accented characters with their unaccented counterparts
    const from = "àáäâèéëêìíïîòóöôùúüûñçľščťžýéď·,:;ůřěůščžďťňýáéíóúýů";
    const to   = "aaaaeeeeiiiioooouuuunclsctzyed----ursczdtnyaeiouy";
    for (let i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

   // Remove invalid characters, allow only lowercase letters, digits, dots, dashes, and underscores
   str = str.replace(/[^a-z0-9._-]/g, '')
            .replace(/\s+/g, '-')       // Replace spaces with dashes
            .replace(/-+/g, '-')        // Collapse multiple dashes
            .replace(/^\W+|\W+$/g, ''); // Remove invalid characters at start or end (non-alphanumeric)

    console.log("final str:" + str);
    return str;
}